var exports = {
  "L": "tokens__DDvM8H",
};

module.exports = exports;
